import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type Language = 'az' | 'en' | 'ru';

interface LanguageState {
    currentLanguage: Language;
}

const initialState: LanguageState = {
    currentLanguage: (localStorage.getItem('selectedLanguage') as Language) || 'az'
}

const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        setLanguage: (state, action: PayloadAction<Language>) => {
            state.currentLanguage = action.payload;
            localStorage.setItem('selectedLanguage', action.payload);
        }
    }
});
export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;